import { API_URL as BASE_URL } from '../config';
import { getToken, getBranchId } from './auth';

const API_URL = `${BASE_URL}/api`;

const authHeaders = () => {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

export const getQuestionGroups = async (branchId) => {
  const bid = branchId || getBranchId() || 1;
  const response = await fetch(`${API_URL}/game/question-groups?branch_id=${bid}`, {
    headers: { 'Content-Type': 'application/json' }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch question groups');
  }

  return response.json();
};

export const createGameSession = async (questionGroupId, ttlHours = 24, customCode = '', gameName = 'CTTA Trivia', countdownSeconds = 5, theme = '') => {
  const payload = {
    questionGroupId,
    ttlHours,
    gameName,
    countdownSeconds,
    theme: theme || '',
    publicUrl: window.location.origin
  };

  if (customCode && customCode.trim()) {
    payload.customCode = customCode.trim();
  }

  const response = await fetch(`${API_URL}/game/create-session`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to create game session');
  }

  return response.json();
};

export const getGameSession = async (sessionCode) => {
  const response = await fetch(`${API_URL}/game/session/${sessionCode}`);

  if (!response.ok) {
    throw new Error('Failed to fetch game session');
  }

  return response.json();
};

export const getSessionLeaderboard = async (sessionCode) => {
  const response = await fetch(`${API_URL}/game/session/${sessionCode}/leaderboard`);

  if (!response.ok) {
    throw new Error('Failed to fetch leaderboard');
  }

  return response.json();
};

export const getAllSessions = async () => {
  const response = await fetch(`${API_URL}/game/sessions`, {
    headers: authHeaders()
  });

  if (!response.ok) {
    throw new Error('Failed to fetch sessions');
  }

  return response.json();
};

export default {
  getQuestionGroups,
  createGameSession,
  getGameSession,
  getSessionLeaderboard,
  getAllSessions
};
